import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './Catalog.scss';
import * as actions from 'src/redux/catalogActions';
import Media from 'react-responsive';
import CatalogHeader from './elements/CatalogHeader.jsx';
import ProductTable from './elements/ProductTable.jsx';
import {getIdByURL} from 'src/logic/utils';
import {first} from 'lodash';

export class Catalog extends Component {
  render() {

    return this.props.children || (
        <div className={styles.Catalog}>
          <Media query="(min-width: 1025px)">
            <CatalogHeader
              whatIsIt="Модели"
              showFilter={true}
              routes={this.props.routes}/>
          </Media>
          <ProductTable
            brand={this.props.brand}
            brandList={this.props.brandList}
            chooseBrand={this.props.chooseBrand}
            getModels={this.props.getModels}
            modelList={this.props.modelList}
            showHideCategoryOnMobile={this.showHideCategoryOnMobile}
            />
        </div>
    );
  }
}

Catalog.routeTitle = "Модели";


export default connect(
  (state) => ({
    ...state.catalogReducer,
    brandList: state.categoriesReducer.brandList }),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(Catalog);



/** WEBPACK FOOTER **
 ** ./src/components/Catalog/Catalog.jsx
 **/